module.exports = __webpack_public_path__ + "img/logo.22e210f2.png";